module.exports = __webpack_public_path__ + "img/曲线.98e4c79b.png";